import { Component, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';

import { changeSearchTypes } from 'SearchAllApp/state/search-all-params/search-all-params.actions';
import { getSearchTypes } from 'SearchAllApp/state/search-all.selectors';

import { SEARCH_ALL_METHODS } from 'SearchApp/ts/constants';
import { SearchAllCategory, SearchTypeInfoCheckbox } from 'SearchApp/ts/types/search-all-category.type';
import { SearchAllRootStore } from 'SearchAllApp/state/interfaces/search-all-store.interface';

/**
 *
 * SearchAllCategoriesComponent.
 *
 * This component is the filter by categories checkboxes.
 */
@Component({
    standalone: false,
    selector: 'ycn-search-all-categories',
    templateUrl: './search-all-categories.template.html',
})
export class SearchAllCategoriesComponent implements OnDestroy {
    searchTypes: SearchTypeInfoCheckbox[] = [];

    private storeSubscription: Subscription;

    constructor(private readonly store: Store<{ reducers: SearchAllRootStore }>) {
        this.storeSubscription = this.store.select('reducers').subscribe(this.mapStateToComponent);
    }

    mapStateToComponent = (state: SearchAllRootStore): void => {
        const activeCategories: SearchAllCategory[] = getSearchTypes(state);
        this.searchTypes = SEARCH_ALL_METHODS.map((searchType) => ({
            ...searchType,
            checked: activeCategories.includes(searchType.searchMethod),
        }));
    };

    ngOnDestroy(): void {
        this.storeSubscription.unsubscribe();
    }

    /**
     * Dispatches `changeSearchTypes` to set the new values for `searchTypes`.
     */
    changeSearchType(): void {
        const searchTypes = this.searchTypes.filter(({ checked }) => checked).map(({ searchMethod }) => searchMethod);
        this.store.dispatch(changeSearchTypes({ searchTypes }));
    }
}
